import Cookies from 'js-cookie';

import {getPreferredInstituteNumber} from 'app/components/instituteSelection/instituteCookies';
import {clientRender} from 'app/core/hydrationProvider';
import {removeExcludedParameters} from 'app/core/socialShare/removeExcludedParameters';
import {getPreferredInstituteConfigFromCookie} from 'app/utils/config/getPreferredInstituteConfigFromCookie';
import {type GemSettings} from 'app/utils/config/interface';
import {getUrlParameters} from 'app/utils/replacePlaceholder/getUrlParameters';
import {getDataFromStorage} from 'app/utils/storage/getDataFromStorage';

export function getClientPlaceholderValues(gemSettings: GemSettings, hydrated?: boolean): Values {
    if (!clientRender(hydrated)) {
        return {
            gemSettings,
        };
    }

    return {
        get gemSettings() {
            return gemSettings;
        },

        get cookies() {
            return Cookies.get();
        },

        get qs_params() {
            return getQsParams();
        },

        get storage() {
            return getDataFromStorage('SESSION');
        },

        get localStorage() {
            return getDataFromStorage('LOCAL');
        },

        get urlParameters() {
            return getUrlParameters();
        },

        get preferredInstitute() {
            return getPreferredInstituteConfigFromCookie(gemSettings);
        },

        get preferredInstituteNumber() {
            return getPreferredInstituteNumber();
        },

        fullUrl: removeExcludedParameters(window.location.href, gemSettings.sharingExcludedParameters),
        protocolHostPathnameUrl: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
        pathnameWithHash: `${window.location.pathname}${window.location.hash}`,
        pathnameWithHashAndQueryParams: `${window.location.pathname}${window.location.search}${window.location.hash}`,
        pageTitle: document.title,

        /**
         * Usage: {{#urlRegex}}[A-Z]{2}\w{10}{{/urlRegex}}
         */
        urlRegex: () => {
            return (pattern: string, render: (value: string | undefined) => string) => {
                const regex = new RegExp(pattern);
                const matches = window.location.href.match(regex);
                return render(matches ? matches[0] : undefined);
            };
        },

        /**
         * Usage: {{#cookieValue}}cookie.name.with.dots{{/cookieValue}}
         */
        cookieValue: () => {
            return (cookieName: string, render: (value: string | undefined) => string) => {
                const exactCookieName = cookieName.trim();
                return render(Cookies.get(exactCookieName));
            };
        },
    };
}

function getQsParams(): Record<string, unknown> | null {
    const gsParams = window.sessionStorage.getItem('qs_params');
    try {
        if (gsParams) {
            return JSON.parse(gsParams);
        }
    } catch (e) {
        console.error(e);
    }

    return null;
}

interface Values {
    cookies?: Record<string, string>;
    qs_params?: Record<string, unknown> | null;
    gemSettings: GemSettings;
    fullUrl?: string;

    [key: string]: unknown;
}
